import styled from 'styled-components'

export const Container = styled.div`
  max-width: 80vw;
  font-size: 2.5rem;
`
